import { BLUE_GREY_200, GREEN_500 } from '@airtel/air-design-system';
export var disabilityInformationConfig = {
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 3000,
  isAutoFormSubmitDebounceAllowed: false,
  stepDetailsProps: {
    title: 'STEP 8',
    heading: 'Disability information',
    avatarIcon: 'DisabilityIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  radioButtonData: {
    title: 'Are you a person with disability?',
    radioButtons: [{
      id: 'Yes',
      label: 'Yes',
      value: 'Yes'
    }, {
      id: 'No',
      label: 'No',
      value: 'No'
    }]
  },
  dropdownsDataProps: {
    disabilityTypesData: {
      placeholder: 'Select document type',
      label: 'Proof of disability',
      postfixIconName: 'DownChevronIcon',
      filterKey: 'subHeading',
      clearSearchOnDropdownListChange: false
    }
  },
  uploadsDataProps: {
    uploadFrontImageDisability: {
      allowFileUploadOnWeb: true,
      uploadContainer: {
        id: 'skyc-front-file-upload',
        uploadCtaTitle: 'Upload',
        postfixTitle: 'front side',
        description: 'Only jpg, png with max size of 5 MB'
      }
    },
    uploadBackImageDisability: {
      allowFileUploadOnWeb: true,
      uploadContainer: {
        id: 'skyc-back-file-upload',
        uploadCtaTitle: 'Upload',
        postfixTitle: 'back side (optional)',
        description: 'Only jpg, png with max size of 5 MB'
      }
    }
  }
};
export var successAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};